import { useEffect, useState } from 'react';
import { ROUTES } from '../../../shared/constants/routes';
import { useSubscribedPlan } from '../../renew-plan/v1/hooks/use-subscribed-plan';
import { useCustomNavigate } from '../../../shared/hooks/use-conversation-navigate';
import { Outlet, useLocation } from 'react-router-dom';

export default function RenewPlanGaurd() {
  const { verifySubscribedPlan, subscribedPlan } = useSubscribedPlan();
  const [isPlanExpired, setIsPlanExpired] = useState<boolean>(false);
  const navigate = useCustomNavigate();
  const location = useLocation();

  useEffect(() => {
    if (typeof subscribedPlan?.canMakeNextPayment === 'boolean') {
      if (!subscribedPlan.canMakeNextPayment) {
        setIsPlanExpired(false);
        return;
      }

      const renewalDate = 'renewalDate' in subscribedPlan ? subscribedPlan.renewalDate : undefined;
      const isExpired = renewalDate ? new Date(renewalDate).getTime() < Date.now() : true;
      setIsPlanExpired(isExpired);
      return;
    }

    const verifySubscription = async () => {
      const res = await verifySubscribedPlan();
      setIsPlanExpired(res);
    };

    verifySubscription();
  }, [subscribedPlan, verifySubscribedPlan]);

  useEffect(() => {
    const currentPath = location.pathname;
    const routesAllowed = [ROUTES.TEAM_MANAGEMENT, `${ROUTES.SETTINGS}${ROUTES.SETTINGS_WABA_CHANNELS}`];
    const allowed =
      routesAllowed.some((route) => route === currentPath) ||
      currentPath.includes('renew-plan') ||
      currentPath.includes('renew');
    if (isPlanExpired && !allowed) {
      const searchParams = new URLSearchParams(location.search);
      navigate({
        href: `${ROUTES.RENEW_PLAN}?postRedirect=${encodeURIComponent(currentPath)}${
          searchParams.toString().length > 0 ? `&${searchParams.toString()}` : ''
        }`,
      });
    }
  }, [isPlanExpired, location.pathname, location.search, navigate]);

  return <Outlet />;
}
